import { translate } from "@/plugins/i18n"
export const genfilterAndSortParams = (query = {}) => {
  const filterAndSortParams = {
    filterProperties: [],
    sortKey: query.sortKey || 0,
    sortRule: query.sortRule || 0
  }
  if (!query.proCatId && !query.proId) {
    return filterAndSortParams
  }
  // Extract values from the $route.query
  const proCatIds = (String(query.proCatId) || "").split("-")
  const proIds = (String(query.proId) || "").split("-")

  // Make sure both arrays are of the same length
  if (proCatIds.length !== proIds.length) {
    console.warn("Mismatched query lengths for proCatId and proId.")
    return filterAndSortParams
  }
  // Convert arrays into the desired object format
  const result = proCatIds.map((proCatId, index) => ({
    proCatId,
    proId: proIds[index]
  }))
  filterAndSortParams.filterProperties = result || []
  return filterAndSortParams
}

export const getWareListAndResultTips = (res, keyword) => {
  let searchResultTip = ""
  let wareList = res.wareList || []
  if (res.noResultData && res.noResultData.resultObject && res.noResultData.resultObject.length > 0) {
    if (res.noResultData.resultTip) {
      searchResultTip = ""
    } else {
      searchResultTip = translate("search.noResultTip", {
        keyword
      })
    }
    wareList = res.noResultData.resultObject[0].wareInfo || res.wareList || []
  } else if (res.spellCheckTip != null && res.spellCheckTip != "") {
    searchResultTip = res.spellCheckTip
  } else {
    const count = res.pageInfo ? res.pageInfo.total : 0
    searchResultTip = translate("search.resultTip", {
      keyword,
      count
    })
  }
  return {
    searchResultTip,
    wareList
  }
}

// 处理 promotion 特殊场景
export const handlePropertyList = (propertyList = []) => {
  let result = []
  try {
    propertyList.forEach(item => {
      if (item.propertyId == "3") {
        const childProperties = item.childProperties || []
        if (childProperties.length) {
          result.push({
            ...item,
            childProperties: childProperties.map(v => ({
              ...v,
              propertyId: "1"
            }))
          })
        }
      } else {
        result.push(item)
      }
    })
  } catch (error) {
    result = propertyList
  }
  return result
}
